import { createSlice } from "@reduxjs/toolkit"


var data=[]


if (localStorage.getItem("requisition") !== null && localStorage.getItem("requisition") !== undefined && localStorage.getItem("requisition") !== "") {

    data = JSON.parse(localStorage.getItem("requisition"))

}


const Insider = createSlice({

    name: "todos",
    initialState: data,
    reducers: {
        getrequisition: (state, action) => {
            localStorage.setItem("requisition", JSON.stringify(action.payload.data))
            state = action.payload.data
            return state
        
          
        },

    },

})

export const { getrequisition } = Insider.actions;
export default Insider.reducer;